const ROOT_DOMAIN = '.vantixcreditsolutions.com'
const ATTRIBUTION_KEYS = [
  'fbclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const

function hasCookie(name: string) {
  return document.cookie
    .split(';')
    .some((item) => item.trim().startsWith(`${encodeURIComponent(name)}=`))
}

function captureAttribution() {
  const params = new URLSearchParams(window.location.search)

  try {
    ATTRIBUTION_KEYS.forEach((key) => {
      const value = params.get(key)
      if (value) sessionStorage.setItem(key, value)
    })
  } catch {
    // Cookie attribution still works if session storage is unavailable.
  }

  const fbclid = params.get('fbclid')
  if (!fbclid || hasCookie('_fbc')) return

  const expires = new Date(Date.now() + 90 * 24 * 60 * 60 * 1000)
  const fbc = `fb.1.${Date.now()}.${fbclid}`
  document.cookie = `_fbc=${encodeURIComponent(fbc)}; Expires=${expires.toUTCString()}; Path=/; SameSite=Lax; Secure; Domain=${ROOT_DOMAIN}`
}

captureAttribution()

export function getStoredAttribution() {
  const attribution: Record<string, string> = {}
  try {
    ATTRIBUTION_KEYS.forEach((key) => {
      const value = sessionStorage.getItem(key)
      if (value) attribution[key] = value
    })
  } catch {
    // Return what was available without interrupting form submission.
  }
  return attribution
}
